export default "__VITE_ASSET__BExvkkr4__"